module.exports = __webpack_public_path__ + "img/s5Img3Big.18be2d55.png";